import React from 'react';
import ConfigModal from '../ConfigModal';
import PropTypes from 'prop-types';
import TierSelect from '../TierSelect';

const SocratesChangeBudgetModal = ({ open, team, tiers, onCancel, onSubmit }) => {
	return (
		<ConfigModal
			title={`Ändra budget`}
			open={open}
			onSubmit={onSubmit}
			onCancel={onCancel}
			values={{
				tiers:
					tiers && team.tierID && tiers[team.tierID - 1] ? tiers[team.tierID - 1].id : undefined,
			}}
			createNew={false}
			disableMask
			formItems={[
				{
					id: 'tiers',
					label: 'Frågor',
					decorator: {
						rules: [{ required: true, message: 'Budget är obligatorisk' }],
					},
					component: <TierSelect tiers={tiers} />,
				},
			]}
		/>
	);
};

SocratesChangeBudgetModal.propTypes = {
	team: PropTypes.object.isRequired,
	open: PropTypes.bool,
	onSubmit: PropTypes.func.isRequired,
	onCancel: PropTypes.func.isRequired,
};

SocratesChangeBudgetModal.defaultProps = {
	open: false,
};

export default SocratesChangeBudgetModal;



// WEBPACK FOOTER //
// ./src/components/socrates/socratesChangeBudgetModal.jsx